import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ReactNode } from "react";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface CheckoutFormSectionProps {
  children: ReactNode;
  className?: string;
}

export const CheckoutFormSection = ({
  className,
  children,
}: CheckoutFormSectionProps) => (
  <div
    className={classNames(
      anchorClassNames("border-secondary-200"),
      "flex flex-col empty:hidden",
      className,
    )}
  >
    {children}
  </div>
);
